package com.wiz3r.database

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class Savings_goals(
  public val id: String,
  public val user_id: String,
  public val name: String,
  public val description: String?,
  public val target_amount: Double,
  public val current_amount: Double?,
  public val deadline: String,
  public val category: String,
  public val priority: String?,
  public val created_date: String,
  public val is_active: Long,
  public val icon_emoji: String?,
  public val created_at: String,
  public val updated_at: String,
  public val last_modified: String,
  public val account_type: String?,
  public val debt_interest_rate: Double?,
  public val debt_remaining_balance: Double?,
  public val debt_remaining_months: Long?,
  public val debt_payment_frequency: String?,
  public val debt_monthly_equivalent_payment: Double?,
)
